<template>
  <b-card class="rounded-0 job-profile-title-card" body-class="px-md-2">
    <div class="px-0 px-lg-2">
      <b-row
        class="align-items-center phairify-color-navy phairify-h2-bold"
      >
        <b-col lg="6" md="6" class="d-flex align-items-center py-2 py-lg-0">
          <div
            class="v2_color_black v2_font_weight_semibold font_size_1250rem"
          >
            {{ jobProfile.title }}
          </div>
          <v-wait for="menu-loading">
            <b-spinner slot="waiting" />
            <b-dropdown
              variant="dots"
              no-caret
              dropright
              toggle-class="p-0"
              menu-class="phairify-dropdown v2_font_weight_semibold  v2_line_height_20"
            >
              <template slot="button-content">
                <i
                  v-b-tooltip.hover
                  title="Select actions for Job profile"
                  class="mdi mdi-dots-vertical v2_font_size_28 v2_color_med_gray"
                />
              </template>
              <b-dropdown-item
                class="v2_dropdown_item"
                @click="$emit('rename')"
              >
                Rename
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item class="v2_dropdown_item" @click="$emit('copy')">
                Copy
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item
                class="v2_dropdown_item delete"
                @click="$emit('delete')"
              >
                Delete
              </b-dropdown-item>
            </b-dropdown>
          </v-wait>
        </b-col>
        <b-col
          md="6"
          class="d-flex justify-content-end align-items-center display-on-phone"
        >
          <span id="post-to-exchange-btn">
            <b-button
              variant="v3_teal_outline"
              class="ml-2"
              :class="!postToExchangeDisabled ? 'post_to_exchange_button' : ''"
              :disabled="postToExchangeLoading || postToExchangeDisabled || isJobQuestionIdsDirty || isJobPostedToExchange"
              @click="$emit('post-to-exchange')"
            >
              <b-spinner small v-if="postToExchangeLoading"/>
              <span v-else>Post to Exchange</span>
            </b-button>
          </span>

          <b-button
              variant="v3_red_outline"
              class="cancel-btn ml-1"
              @click="$router.push('/user/exchange')"
          >
            Cancel
          </b-button>
          <b-tooltip v-if="postToExchangeDisabled" target="post-to-exchange-btn">
            You need to complete all questions before be able to post to exchange
          </b-tooltip>
          <b-tooltip v-else-if="isJobQuestionIdsDirty" target="post-to-exchange-btn">
            You need to save your answer before be able to post to exchange
          </b-tooltip>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'JobProfileTitleCard',
  props: {
    jobProfile: {
      type: Object,
      required: true,
    },
    isJobProfileNew: {
      type: Boolean,
      default: false,
    },
    postToExchangeLoading: {
      type: Boolean,
      default: false,
    },
    postToExchangeDisabled: {
      type: Boolean,
      default: false,
    },
    isJobPostedToExchange: {
      type: Boolean,
      default: false,
    },
    isJobQuestionIdsDirty: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/variables_mixins.scss';

.job-profile-title-card {
  @media (min-width: 991px) {
    position: sticky;
    top: 0;
    z-index: 1;
  }
}
.job-profile-title-card-header {
  min-height: 90px;
}
@media (min-width:320px) and (max-width: 567px) {
 .display-on-phone{
   display: block !important;
 }
  .display-on-phone .btn{
    width: 100% !important;
    margin-left: unset !important;
    margin-top: 10px;
  }
}
.post_to_exchange_button {
  background-color: #d0de3a;
  color: $phairify_v2_color_primary_teal;
  &:hover {
    background-color: #d0de3a !important;
    color: $phairify_v2_color_primary_teal !important;
  }
}
</style>
